import { createAsyncThunk } from '@reduxjs/toolkit';

import { environment } from '../../environments';
import { GetActivityTypesRequest, GetActivityTypesResponse, GetProjectActivityRequest, GetProjectActivityResponse } from '../../models/Activity.model';

const API_BASE_URL = environment.apiUrl;

export const GetActivityTypes = createAsyncThunk<
  GetActivityTypesResponse,
  GetActivityTypesRequest,
  { rejectValue: string }
>("activity/GetActivityTypes", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Activity/GetActivityTypes`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: GetActivityTypesResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to fetch base tables");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});

// קבלת ערכים לטבלה ספציפית
export const GetProjectActivity = createAsyncThunk<
  GetProjectActivityResponse,
  GetProjectActivityRequest,
  { rejectValue: string }
>("activity/getProjectActivity", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Activity/GetProjectActivity`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: GetProjectActivityResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to fetch table values");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});

